import React, { useEffect, useContext, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import styles from './style.module.css';

import BookingForm from './BookingForm';
import UpcomingBooking from './UpcomingBooking';
import { Container } from 'react-bootstrap';

import TimelineHeatmap from './TimelineHeatmap';
import { Modal } from 'antd';
import { toast, ToastContainer } from 'react-toastify';
import LocationList from './LocationList';
import GuestLocationBrowser from './LocationList/GuestLocationBrowser';
import locationStyles from './LocationList/LocationList.module.css';
import MoreInfo from './MoreInfo';
import { BookingsContext } from './BookingContext';
import mfaStyles from '../../../LoginComponents/MFAValidation.module.css';

import MapView from './MapView';


import { setFutureEstimateAmount } from '../../../Actions/Auth'

// import MapView from './MapView';
import { useWebSocket } from '../../../Utils/WebSocketContext';
import { Navigate } from 'react-router';
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import ChargingMethodSelector from './ChargingMethodSelector';
import NonReservable from './NonReservable';
import HomeCharging from './HomeCharging/HomeCharging';
import BookingFormNonRes from './BookingFormNonRes';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import { ButtonCustom } from '../../../BootstrapComponents/ButtonCustom';
import Helper from '../../../Utils/Helper'


const UserDashboard = ({ user, userID, location, timeFormatAmPm, type, isUserTester, userGroups, usersFreeChargingLocations, isGuest }) => {

    

    const [bookings, setBookings] = useState([]);

    const [redirectToBookings, setRedirectToBookings] = useState(false);


    const [isSessionFormShow, setIsSessionFormShow] = React.useState(false);


    const { refetchBookings, bookingsData, userBookings, chargersData, selectedDate, changeDate, selectedLocation, setSelectedLocation, selectedPublicLocation, setSelectedPublicLocation, isBookingLoading, connectorData } = useContext(BookingsContext);
    // console.log("chargers DAta in dashboard: ", chargersData)
    // console.log("bookingsData", bookingsData)
    // console.log("connector data from context in dashboard: ", connectorData)
    // Guests never get map view - always start (and stay) on timeline view.
    const [ismapView, setIsMapView] = useState(isGuest ? false : (selectedLocation ? false : true));
    const [guestPreviewLocation, setGuestPreviewLocation] = useState(null);
    const [guestLocationBreadcrumb, setGuestLocationBreadcrumb] = useState(null);

    // const [newBooking, setNewBooking] = useState({})

    const [selectedTime, setSelectedTime] = useState(null);

    const costPerMinute = 4.2 / 60;   //Utilized energy charge for 50 mins
    const dispatch = useDispatch()

    const webSocket = useWebSocket();

    const [extraTimeList, setExtraTimeList] = useState([]);

    const [quickStart, setQuickStart] = useState(false);

    const [locationData, setLocationData] = useState([]);

    const [chargingMethod, setChargingMethod] = useState(null);
    const [nonResFilter, setNonResFilter] = useState(''); // search term for non-reservable chargers

    const [selectedChargerForNonRes, setSelectedChargerForNonRes] = useState(null)

    const [locationChargers, setLocationChargers] = useState(null)

    const [res, setRes] = useState([])

    const [nonRes, setNonRes] = useState([])

    const [subLocations, setSubLocations] = useState(
        location?.filter(loc => String(loc.parentLocation[0]) === String(selectedLocation))
    )

    // console.log("Locations in user dashboard: ", location)
    // console.log("selected location in user dashboard: ", selectedLocation)
    // console.log("sublocations in user dashboard: ", subLocations)

    // console.log("selected locatino in user dash: ", selectedLocation)
    // console.log("location data in user dash: ", locationData)

    const uselocation = useLocation();
    const navigate = useNavigate();
    const onBreatheIconClick = uselocation.state?.onBreatheIconClick || false;
    useEffect(() => {
        if (onBreatheIconClick) {
            if (!isGuest) {
                setIsMapView(true);
            }
            navigate(location.pathname, { replace: true });
        }
    }, [onBreatheIconClick, navigate, location.pathname, isGuest]
    );

    useEffect(() =>{
        setSubLocations(location?.filter(loc => String(loc.parentLocation[0]) === String(selectedLocation)))
    },[selectedLocation, location])

    // user may belong to more than one CONDO sub location under the same parent
    const condoSubLocations = (subLocations || []).filter(loc => loc.subLocationType === "CONDO")
    const [selectedSubLocationId, setSelectedSubLocationId] = useState(null)
    const selectedSubLocation = condoSubLocations.find(loc => String(loc._id) === String(selectedSubLocationId)) || condoSubLocations[0]

    useEffect(() => {
        setSelectedSubLocationId(null)
    }, [selectedLocation])


    let bookingSlots = [];


    if (webSocket) {
        webSocket.addEventListener('message', function (event) {
            if (JSON.parse(event.data).type === "refetch_data") {
                setTimeout(() => {
                    refetchBookings && refetchBookings();
                }, 1000);
            }
        });
    }

    //   webSocket.addEventListener('message', function (event) {
    //         // console.log('Message from server in dashboard: ', event.data);
    //     //     // setData(event.data);  // Update state with received data
    //     });



    // const getPrice = (futureDuration = 0) => {
    //     return (costPerMinute * (parseFloat(futureDuration)));
    //   }

    const getLocationCharger = async (locationId) => {
        try {
            const response = await BreathAPIs.getAllChargersByLocation(locationId);
            // console.log("location chargers", response.data.chargers)    
            setLocationChargers(response.data.chargers);
            // setLocationChargers(null)
        } catch (error) {
            setLocationChargers([])
            console.error("Error fetching location chargers:", error);
        }
    }

    useEffect(() => {
        setChargingMethod(null)
        setLocationChargers(null)
        setRes([])
        setNonRes([])
        if (selectedLocation) {
            getLocationCharger(selectedLocation);
        }
    }, [selectedLocation]);

    useEffect(() =>{
        if(selectedLocation && chargingMethod === 'non-reservable'){ 
            console.log("fetching location chargers for non-reservable")
        refetchBookings();
        }
    }, [chargingMethod])

    const LocationDataFixing = async (location, selectedLocation) => {
        let selectedLocationData = location.filter((l) => l._id === selectedLocation)
        let selectedTimeVar = selectedTime ? selectedTime : new Date()
        // console.log("selected Location data ", selectedLocationData)
        if (selectedLocationData.length === 0) {
            let locationFetchResponse = await BreathAPIs.getLocation(selectedLocation)
            // console.log("Location data from api call", locationFetchResponse)
            // console.log("locationFetchResponse.data.location", locationFetchResponse.data.location)
            let locationDataArray = []
            locationDataArray.push(locationFetchResponse?.data?.location)
            if((locationDataArray?.[0] != undefined && locationDataArray[0].userMaxDurationLimit === true)){
                
                let chargerTime = Helper.convertToChargerTimeZone(new Date(selectedTimeVar), locationDataArray[0].timezone) 
                let chargerTimeEnd = chargerTime
                let offSetBetweenChargerAndLocal = selectedTimeVar ? selectedTimeVar.getTime() - chargerTime.getTime() : 0
                console.log("chargerTime, chargerTimeEnd", chargerTime, chargerTimeEnd)
                let dayStart = chargerTime.setHours(0,0,0,0)
                let dayEnd = chargerTimeEnd.setHours(23, 59, 59, 999)
                dayStart = new Date(new Date(dayStart).getTime() + offSetBetweenChargerAndLocal)
                dayEnd = new Date(new Date(dayEnd).getTime() + offSetBetweenChargerAndLocal)
                try{
                    let res = await BreathAPIs.getCurrentDayUserBookings(dayStart, dayEnd)
                    let maxAllowedDurationForLoc = locationDataArray[0].maxChargeDuration * 60 * 60
                    let usedSecByUser = res.data
                    let availableDuration = (Math.trunc((maxAllowedDurationForLoc - usedSecByUser)/15) * 15) / 3600
                    setLocationData([{ ...locationDataArray[0], maxChargeDuration: availableDuration }])


                }catch(err){
                    console.log("ërr in api call", err.message)
                }
                
            }else{
                setLocationData(locationDataArray)
            }
            
            // fetch details for the selectedLocation
        } else {
            if(selectedLocationData?.[0] != undefined && selectedLocationData[0].userMaxDurationLimit === true){
                let chargerTime = Helper.convertToChargerTimeZone(new Date(selectedTimeVar), selectedLocationData[0].timezone) 
                let chargerTimeEnd = chargerTime
                let offSetBetweenChargerAndLocal = selectedTimeVar ? selectedTimeVar.getTime() - chargerTime.getTime() : 0
                console.log("chargerTime, chargerTimeEnd", chargerTime, chargerTimeEnd)
                let dayStart = chargerTime.setHours(0,0,0,0)
                let dayEnd = chargerTimeEnd.setHours(23, 59, 59, 999)
                dayStart = new Date(new Date(dayStart).getTime() + offSetBetweenChargerAndLocal)
                dayEnd = new Date(new Date(dayEnd).getTime() + offSetBetweenChargerAndLocal)
                try{
                    let res = await BreathAPIs.getCurrentDayUserBookings(dayStart, dayEnd)
                    let maxAllowedDurationForLoc = selectedLocationData[0].maxChargeDuration * 60 * 60
                    let usedSecByUser = res.data
                    console.log("maxAllowedDurationForLoc, usedSecByUser", maxAllowedDurationForLoc, usedSecByUser)
                    let availableDuration = (Math.trunc((maxAllowedDurationForLoc - usedSecByUser)/15) * 15) / 3600
                    setLocationData([{ ...selectedLocationData[0], maxChargeDuration: availableDuration }])
                }catch(err){
                    console.log("ërr in api call", err.message)
                    setLocationData(selectedLocationData)
                }
            }else{
                // console.log('time zone response', Helper.convertToChargerTimeZone(new Date(), selectedLocationData[0].timezone))
                setLocationData(selectedLocationData)
            }
        }
        //    return location.filter((l) => l._id === selectedLocation)
    }
    useEffect(() => {
        setChargingMethod(null)
        setLocationChargers(null)
        setRes([])
        setNonRes([])
        LocationDataFixing(location, selectedLocation)
    }, [selectedLocation])

    useEffect(()=>{
        LocationDataFixing(location, selectedLocation)
    }, [selectedTime])

    


    const handleToast = (type, text) => {
        if (type === 'success') {
            toast.success(text)
            setIsSessionFormShow(false)
        } else if (type === 'error') {
            toast.error(text)
        } else if (type === 'warning') {
            toast.warning(text)
            setIsSessionFormShow(false)
        }
        // type=='success' ? toast.success(text) : toast.error(text); (type=='success') && setIsSessionFormShow(false)

    }

    const handleNewBooking = (newBooking) => {
        // setNewBooking(newBooking)
        setRedirectToBookings(true);
    }

    useEffect(() => {
        setBookings(bookingsData);
    }, [bookingsData]);

    const [nearbyPublicLocations, setNearbyPublicLocations] = useState([]);

    useEffect(() => {
        const fetchLocations = async ({ latitude, longitude }) => {
            try {
                const { data } = await BreathAPIs.getNearbyPublicLocations(latitude, longitude);
                setNearbyPublicLocations(data);
            } catch (error) {
                console.error("Error fetching locations:", error);
            }
        };
        // let coordinate ={latitude:0,longitude:0}
        navigator.geolocation?.getCurrentPosition(
            ({ coords }) => {
                fetchLocations(coords)
            },
            (error) => {
                fetchLocations({ latitude: 0, longitude: 0 })
                console.error("Error fetching location:", error)
            }
        );
        // console.log(coordinate.latitude)

    }, []);



    //UserDashboardChargerFilter start

    function getDateFromTimeString(timeString) {
        const [hours, minutes, seconds] = timeString.split(':');
        const [secs, millis] = seconds.split('.');
        const date = new Date();
        date.setHours(hours, minutes, secs, millis);
        return date;
    }

    function getTimeDifference(timeString) {
        let [time1, time2] = timeString.split("-")
        let date1 = getDateFromTimeString(time1)
        let date2 = getDateFromTimeString(time2)
        if (date2 < date1) {
            date2.setDate(date2.getDate() + 1);
        }
        const timeDifference = date2 - date1;
        return timeDifference // in millisec
    }


    // find time in charger timezone
    // attach to selected, prev and next day
    // check for applicable days 
    // if applicable convert into local timezone and attach to booked slots
    function getTimeZoneOffsetTwoTimezone(timeZone1, timeZone2, date = new Date()) {
        // Create a date object for both time zones
        const dateInTimeZone1 = new Date(date.toLocaleString('en-US', { timeZone: timeZone1 }));
        const dateInTimeZone2 = new Date(date.toLocaleString('en-US', { timeZone: timeZone2 }));
        // Get the difference in time in milliseconds
        const timeDifferenceInMilliseconds = dateInTimeZone2.getTime() - dateInTimeZone1.getTime();
        // Convert from milliseconds to hours
        // const timeDifferenceInHours = timeDifferenceInMilliseconds / (1000 * 60 * 60);
        return timeDifferenceInMilliseconds;
    }

    function findLimitingBookedSlots() {
        // console.log("locationData.sharedTime", locationData[0].sharedTime)
        let sharedTimes = locationData[0]?.sharedTime
        let newBookingSlots = []
        let daysToCheck = [new Date(new Date(selectedDate).setDate(new Date(selectedDate).getDate() - 1)), new Date(selectedDate), new Date(new Date(selectedDate).setDate(new Date(selectedDate).getDate() + 1))]
        // console.log(daysToCheck)

        daysToCheck.map((checkingDay) => {
            sharedTimes.map((timeRangeObject) => {
                // start time attach to slected day,(local time(setUTC))          #selected day - 1, selected day + 1
                // convet to charger time zone
                // check for applicable day
                // if applicable  
                // add offset to find end time 
                // change to local time zone 
                // create slot 

                let currentDay = new Date(checkingDay)
                // console.log("selected day: ", currentDay)
                let [startTime, endTime] = timeRangeObject.timeRange.split('-')
                let [hours, minutes, seconds] = startTime.split(':')
                const [secs, millis] = seconds.split('.');
                currentDay.setUTCHours(hours, minutes, secs, millis)
                let rangeEndTimeInLocal = new Date(currentDay.getTime() + getTimeDifference(timeRangeObject.timeRange))
                // console.log("rangeendtime in local: ", rangeEndTimeInLocal)
                // console.log("currentDay: ", currentDay)

                // if(selectedDate.getDate() !== currentDay.getDate()){
                //     if(selectedDate > currentDay){
                //         currentDay.setDate(currentDay.getDate()+1)
                //     }else if(selectedDate < currentDay){
                //         currentDay.setDate(currentDay.getDate()-1)
                //     }
                // }

                // currentDay.setUTCHours(hours)
                // currentDay.setUTCMinutes(minutes)
                // currentDay.setUTCSeconds(seconds)
                // console.log("start time attached selected day in local timezone: ", currentDay)

                // console.log("end time stamp in local timezone: ", rangeEndTimeInLocal)
                // if(currentDay>rangeEndTimeInLocal){
                //     console.log("range start in local is greater than range end in local")
                //     currentDay.setDate(currentDay.getDate()-1)
                // }
                const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                // console.log(timeZone)
                let timeZoneOffSet = getTimeZoneOffsetTwoTimezone(localTimeZone, locationData[0]?.timezone, currentDay) // offset depends on order of timezones
                // console.log("offset of target time zone form local: ", )
                let startTimeInChargerTime = new Date((currentDay.getTime() + timeZoneOffSet))

                // console.log(startTimeInChargerTime.getDay())
                // console.log(startTimeInChargerTime)
                let endTimeInChargerTime = startTimeInChargerTime.getTime() + getTimeDifference(timeRangeObject.timeRange)
                // console.log("endTimeInChargerTime: ", new Date(endTimeInChargerTime))
                // let updatedEndTimeInLocalTimezone = new Date(endTimeInChargerTime - timeZoneOffSet)
                // let updatedstartTimeInLocalTimezone = new Date(startTimeInChargerTime.getTime()-timeZoneOffSet)
                // let newBookingSlot = 
                let updatedLocalStartTime = new Date(startTimeInChargerTime.getTime() - timeZoneOffSet)
                let updatedLocalEndTime = new Date(endTimeInChargerTime - timeZoneOffSet)
                // console.log("final date range in local : ")
                // console.log("updated start time in local timzone: ", updatedLocalStartTime)
                // console.log("updated end time in local timezone", updatedLocalEndTime)


                if (timeRangeObject.applicableDays[startTimeInChargerTime.getDay()] === 1) {
                    // console.log("time range is applicable in selected date")

                    // if( updatedLocalStartTime > rangeEndTimeInLocal){
                    //     console.log("inside local span condition: before setting start date", new Date(startTimeInChargerTime.getTime()-timeZoneOffSet))
                    //     console.log("range end time local timezone ", rangeEndTimeInLocal)
                    //     updatedLocalStartTime.setDate(updatedLocalStartTime.getDate()-1)
                    //     console.log("inside local span condition: after setting start date", updatedLocalStartTime)
                    // }

                    newBookingSlots.push({ end: updatedLocalEndTime, start: updatedLocalStartTime })
                    // console.log("updated slot time in local timezone , ", newBookingSlot)
                    // console.log(updatedstartTimeInLocalTimezone)
                    // console.log(updatedEndTimeInLocalTimezone)

                } else {
                    return
                }


            })
        })
        // setUpdatedBookedSlots(newBookingSlots)
        return newBookingSlots;
    }


    let chargingStations = [];
    let chargingStationsNonReservable = [];
    let chargingStationsNonReservableOffline = [];

    let chargingStationsConnectors = []
    let chargingStationsNonReservableConnectors = [];
    let chargingStationsNonReservableOfflineConnectors = [];

    connectorData?.map((connector) => {

        // console.log("bookings in dashboard: ", bookings)
        bookingSlots = bookings?.filter(item => item.connector._id === connector._id).map(item => (
            { start: new Date(item.startTime), end: new Date(item.endTime) }));
        // console.log("bookingSlots in dashboard: ", bookingSlots)
        // add bookingSlots here

        // console.log("location ", location)
        // console.log("selected location: ", locationData)
        // console.log("data of booking slots", bookingSlots)
        // console.log("data of limiting slots", findLimitingBookedSlots())
        let isUsersLocation = location.some(item => item._id === locationData[0]?._id)
        // console.log("isUsersLocation", locationData)
        if (!isUsersLocation) {
            if (locationData[0]?.locationType === "SHARED-PUBLIC") {
                bookingSlots = bookingSlots?.concat(findLimitingBookedSlots())
            } else if (locationData[0]?.locationType === "SHARED-PRIVATE") {
                // console.log("giving acces to public users only in public times.")
                let availablePublicTimes = findLimitingBookedSlots()
                let unavailablePublicSlots = []
                availablePublicTimes.sort((a, b) => new Date(a.start) - new Date(b.start));
                // console.log("availablePublicTimes: ", availablePublicTimes)
                availablePublicTimes.map((item, index) => {
                    let startTime;
                    let endTime;
                    if (index === 0) {
                        startTime = new Date(new Date(item.start).setHours(0, 0, 0, 0))
                    } else {
                        startTime = new Date(new Date(availablePublicTimes[index - 1].end).getTime() + 1)
                    }
                    endTime = new Date(new Date(item.start).getTime() - 1)
                    unavailablePublicSlots.push({ end: endTime, start: startTime })
                })
                if (availablePublicTimes.length > 0) {
                    unavailablePublicSlots.push({ end: new Date(new Date(new Date(availablePublicTimes[availablePublicTimes.length - 1].end).getTime() + 1).setHours(23, 59, 59, 999)), start: new Date(new Date(availablePublicTimes[availablePublicTimes.length - 1].end).getTime() + 1) })
                }
                // console.log(unavailablePublicSlots)
                bookingSlots = bookingSlots?.concat(unavailablePublicSlots)
                // current time to start - 1 ms 
                // end time+1ms to next start 
            }
            // "SHARED-PUBLIC"

            // location id not in user's location:
            //     public User:
            //         add booked slots with time range(private slots)

            // "SHARED-PRIVATE"

            // location id not in user's location:
            //     public user:
            //         add booked slots with time range except the 				shared time
        }

        // console.log("data of booking slots", bookingSlots)
        // console.log("charger")
        // console.log("chargerData in dashboard: ", chargersData)
        // console.log("connector full data in dashboard: ", connectorData)
        // console.log("connector in dashboard: ", connector)
        let charger = chargersData?.find(charger => charger._id === connector.charger);
        // console.log("charger in dashboard: ", charger)
        // console.log("bookingSlots in dashboard: ", bookingSlots)
        // console.log("connector in dashboard: ", connector)
        if (connector?.nonReservable) {
            if (connector?.chargerStatus === "Online") {
                chargingStationsNonReservableConnectors.push({
                    id: charger._id,
                    bookedSlots: bookingSlots,
                    title: charger.chargerTag,
                    connectorType: connector?.type,
                    chargerStatus: connector?.chargerStatus,
                    power: connector?.power,
                    dynamicRates: charger.dynamicRates,
                    status: connector?.status,
                    rateType: charger.rateType,
                    normalRate: charger.rate.price_components.price,
                    tax: charger.rate.price_components.tax,
                    nonReservable: true,
                    rate: charger.rate,
                    connectorID: connector?._id,
                    connectorNumber: connector?.connectorNumber,
                    noOfConnectorsInCharger: connector?.noOfConnectorsInCharger,
                    orderingNumber: charger.orderingNumber,
                    chargerLevel: charger?.chargerLevel,
                    lastSessionEndTime: charger?.lastSessionEndTime
                });
            }
            else {
                chargingStationsNonReservableOfflineConnectors.push({
                    id: charger._id,
                    bookedSlots: bookingSlots,
                    title: charger.chargerTag,
                    connectorType: connector?.type,
                    chargerStatus: connector?.chargerStatus,
                    power: connector?.power,
                    dynamicRates: charger.dynamicRates,
                    status: connector?.status,
                    rateType: charger.rateType,
                    normalRate: charger.rate.price_components.price,
                    tax: charger.rate.price_components.tax,
                    nonReservable: true,
                    rate: charger.rate,
                    connectorID: connector?._id,
                    connectorNumber: connector?.connectorNumber,
                    noOfConnectorsInCharger: connector?.noOfConnectorsInCharger,
                    orderingNumber: charger.orderingNumber,
                    chargerLevel: charger?.chargerLevel,
                    lastSessionEndTime: charger?.lastSessionEndTime
                });
            }

        }
        else {
            chargingStationsConnectors.push({
                id: charger._id,
                bookedSlots: bookingSlots,
                title: charger.chargerTag,
                connectorType: connector?.type,
                chargerStatus: connector?.chargerStatus,
                power: connector?.power,
                dynamicRates: charger.dynamicRates,
                rateType: charger.rateType,
                normalRate: charger.rate.price_components.price,
                nonReservable: false,
                tax: charger.rate.price_components.tax,
                connectorID: connector?._id,
                connectorNumber: connector?.connectorNumber,
                noOfConnectorsInCharger: connector?.noOfConnectorsInCharger,
                orderingNumber: charger.orderingNumber,
                chargerLevel: charger?.chargerLevel
            });
        }

    });

    // chargersData?.map((charger) => {


    //     bookingSlots = bookings?.filter(item => item.charger._id === charger._id).map(item => (
    //         { start: new Date(item.startTime), end: new Date(item.endTime) }));

    //     // add bookingSlots here

    //     // console.log("location ", location)
    //     // console.log("selected location: ", locationData)
    //     // console.log("data of booking slots", bookingSlots)
    //     // console.log("data of limiting slots", findLimitingBookedSlots())
    //     let isUsersLocation = location.some(item => item._id === locationData[0]?._id)
    //     // console.log("isUsersLocation", locationData)
    //     if(!isUsersLocation){
    //         if(locationData[0]?.locationType === "SHARED-PUBLIC"){
    //             bookingSlots = bookingSlots?.concat(findLimitingBookedSlots())
    //         }else if(locationData[0]?.locationType === "SHARED-PRIVATE"){
    //             // console.log("giving acces to public users only in public times.")
    //             let availablePublicTimes = findLimitingBookedSlots()
    //             let unavailablePublicSlots = []
    //             availablePublicTimes.sort((a, b) => new Date(a.start) - new Date(b.start));
    //             console.log("availablePublicTimes: ", availablePublicTimes)
    //             availablePublicTimes.map((item, index)=>{
    //                 let startTime;
    //                 let endTime;
    //                 if(index===0){
    //                     startTime = new Date(new Date(item.start).setHours(0,0,0,0))
    //                 }else{
    //                     startTime = new Date(new Date(availablePublicTimes[index-1].end).getTime()+1)
    //                 }
    //                 endTime = new Date(new Date(item.start).getTime()-1)
    //                 unavailablePublicSlots.push({end: endTime, start: startTime})
    //             })
    //             if(availablePublicTimes.length > 0){
    //                 unavailablePublicSlots.push({end: new Date(new Date(new Date(availablePublicTimes[availablePublicTimes.length-1].end).getTime()+1).setHours(23, 59, 59, 999)), start: new Date(new Date(availablePublicTimes[availablePublicTimes.length-1].end).getTime()+1)})
    //             }
    //             // console.log(unavailablePublicSlots)
    //             bookingSlots = bookingSlots?.concat(unavailablePublicSlots)
    //             // current time to start - 1 ms 
    //             // end time+1ms to next start 
    //         }
    //         // "SHARED-PUBLIC"

    //             // location id not in user's location:
    //             //     public User:
    //             //         add booked slots with time range(private slots)

    //         // "SHARED-PRIVATE"

    //             // location id not in user's location:
    //             //     public user:
    //             //         add booked slots with time range except the 				shared time
    //     }

    //     // console.log("data of booking slots", bookingSlots)

    //     if(charger?.nonReservable) {
    //         if(charger?.chargerStatus === "Online") {
    //             chargingStationsNonReservable.push({
    //                 id: charger._id,
    //                 bookedSlots: bookingSlots,
    //                 title: charger.chargerTag,
    //                 connectorType: charger?.connector[0]?.type,
    //                 chargerStatus: charger?.chargerStatus,
    //                 power: charger?.connector[0]?.power,
    //                 dynamicRates: charger.dynamicRates,
    //                 status: charger.connector[0]?.status,
    //                 rateType: charger.rateType,
    //                 normalRate: charger.rate.price_components.price,   
    //                 tax: charger.rate.price_components.tax,
    //                 nonReservable: true,
    //                 rate: charger.rate,
    //                 connectorID: charger?.connector[0]?._id
    //             });
    //         }
    //         else {
    //             chargingStationsNonReservableOffline.push({
    //                 id: charger._id,
    //                 bookedSlots: bookingSlots,
    //                 title: charger.chargerTag,
    //                 connectorType: charger?.connector[0]?.type,
    //                 chargerStatus: charger?.chargerStatus,
    //                 power: charger?.connector[0]?.power,
    //                 dynamicRates: charger.dynamicRates,
    //                 status: charger.connector[0]?.status,
    //                 rateType: charger.rateType,
    //                 normalRate: charger.rate.price_components.price,   
    //                 tax: charger.rate.price_components.tax,
    //                 nonReservable: true,
    //                 rate: charger.rate, 
    //                 connectorID: charger?.connector[0]?._id
    //             });
    //         }

    //     }
    //     else {
    //         chargingStations.push({
    //             id: charger._id,
    //             bookedSlots: bookingSlots,
    //             title: charger.chargerTag,
    //             connectorType: charger?.connector[0]?.type,
    //             chargerStatus: charger?.chargerStatus,
    //             power: charger?.connector[0]?.power,
    //             dynamicRates: charger.dynamicRates,
    //             rateType: charger.rateType,
    //             normalRate: charger.rate.price_components.price,   
    //             nonReservable: false,
    //             tax: charger.rate.price_components.tax
    //         });
    //     }

    // });

    //UserDashboardChargerFilter end

    // const {
    //     chargingStations,
    //     chargingStationsNonReservable,
    //     chargingStationsNonReservableOffline
    // } = UserDashboardChargerFilter(chargersData, locationData,location, selectedDate, bookings)
    // ?

    useEffect(() => {

        setRes([])
        setNonRes([])
        let resLocalArray = []
        let nonResLocalArray = []

        if (locationChargers !== null) {
            locationChargers.map((charger) => {
                charger.connector.forEach((conn) => {
                    if (conn.nonReservable === true) {
                        setNonRes([...nonRes, conn])
                        nonResLocalArray.push(conn)
                    }
                    else {
                        setRes([...res, conn])
                        resLocalArray.push(conn)
                    }
                })

            })
            
            if(chargingMethod === null){

                if(subLocations?.length > 0 && subLocations[0].subLocationType === "CONDO"){
                setChargingMethod('home')
            }
                else if (resLocalArray.length > 0) {
                // console.log('reservable')
                setChargingMethod('reservable')
            }
            else if (nonResLocalArray.length > 0 && resLocalArray.length === 0) {
                // console.log('non-reservable')
                setChargingMethod('non-reservable')
            } 
            else if(nonResLocalArray.length ===0 
                && resLocalArray.length === 0 
                && (subLocations?.length > 0 && subLocations[0].subLocationType === "CONDO")){
                    setChargingMethod('home')
            }
            else {
                // console.log('else reservable')
                setChargingMethod('reservable')
            }
            }

            
        }

        // console.log('useEffecr', res.length, nonRes.length)
    }, [locationChargers, selectedLocation]);

    // console.log("charging station data to heat map: ", chargingStations)
    // console.log("selected date", selectedDate)
    // console.log("selected Location: ", locationData)
//    console.log("chargingStationsNonReservableConnectors",chargingStationsNonReservableConnectors)

    // Combine online and offline non-reservable connectors so all are listed by default
    const allNonResConnectors = [
        ...(chargingStationsNonReservableConnectors || []),
        ...(chargingStationsNonReservableOfflineConnectors || [])
    ];

    // Show all by default; when user types a search term, filter the combined list
    const filteredNonResConnectors = (nonResFilter && nonResFilter.trim() !== '')
        ? allNonResConnectors.filter(ch => ch.title && ch.title.toLowerCase().includes(nonResFilter.toLowerCase()))
        : allNonResConnectors;

    const setLocationCallBack = (location) => {
        setSelectedLocation(location)
    }

    if (redirectToBookings) {
        const bookingSuccess = true;
        return <Navigate to='/bookingHist' state={{ bookingSuccess }} />;
    }

    // Guests must not reach the timeline without a location picked - this covers
    // a reload where nothing was ever selected (or the saved selection's token no
    // longer matches), not the case where one is already selected and still loading.
    const handleGuestLocationSelected = (selectedLoc) => {
        localStorage.setItem('selectedLocation', selectedLoc._id);
        localStorage.setItem('selectedLocationToken', localStorage.getItem('token'));
        setLocationCallBack(selectedLoc._id);
    };

    if (isGuest && !selectedLocation) {
        return (
            <div className={styles['user-dashboard-container']}>
                <div className={styles['no-charging-stations']}>
                    <div className={styles['guestLocationGate']}>
                        <div className={mfaStyles.iconCircle}>
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2L4 5V11C4 16.5 7.4 21.7 12 23C16.6 21.7 20 16.5 20 11V5L12 2Z" stroke="#18365E" strokeWidth="1.6" strokeLinejoin="round" />
                                <path d="M9 12L11 14L15.5 9.5" stroke="#18365E" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <h5 className={mfaStyles.title}>Select a Location</h5>
                        <p className={mfaStyles.subtitle}>Choose where you&#39;ll be charging to continue.</p>
                        {guestLocationBreadcrumb}
                        <div className={`${locationStyles['location-browser-panel']} ${styles['guestLocationPanelScroll']}`}>
                            <GuestLocationBrowser selectedLocationId={null} onPreviewLocationChange={setGuestPreviewLocation} onBreadcrumbChange={setGuestLocationBreadcrumb} />
                        </div>
                        {guestPreviewLocation && (
                            <ButtonCustom
                                variant="primary"
                                text="Continue"
                                onClick={() => handleGuestLocationSelected(guestPreviewLocation)}
                                style={{ width: '100%', marginTop: '12px', backgroundColor: '#18365E', borderColor: '#18365E' }}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }



    // function getNonReserveBookingData(data){
    //     console.log("data from non reserve: ", data)
    // }

    const checkSlotTaken = (time) => {
        let selectedBookings = [];

        const startTimeChk = new Date(time);
        startTimeChk.setMinutes(startTimeChk.getMinutes() - 15)

        const endDateTimeChk = new Date(time);
        endDateTimeChk.setMinutes(endDateTimeChk.getMinutes() + 15)



        for (let booking of userBookings) {
          if (
            (
                (new Date(booking.startTime).getTime() <= startTimeChk.getTime() && startTimeChk.getTime() < new Date(booking.isNightCharging ? booking.endTimeOverNight : booking.endTime).getTime()) ||
                (new Date(booking.startTime).getTime() < endDateTimeChk.getTime() && endDateTimeChk.getTime() <= new Date(booking.isNightCharging ? booking.endTimeOverNight : booking.endTime).getTime()) ||
                (startTimeChk.getTime() <= new Date(booking.startTime).getTime() && new Date(booking.isNightCharging ? booking.endTimeOverNight : booking.endTime).getTime() <= endDateTimeChk.getTime())
            )
            // && (userID === booking?.user?._id)
          ) {
            // console.log(booking)
            selectedBookings.push(booking);
          }
        }


        if (selectedBookings?.length) {
            const tenMinutesBeforeEnd = Date.now() + 11 * 60 * 1000;
        
            const result = selectedBookings.find(booking => 
                booking.endTime && new Date(booking.isNightCharging ? booking.endTimeOverNight : booking.endTime).getTime() > tenMinutesBeforeEnd
            );

            return result || false;


        }

        return false;

    }

    const timelineSlotClick = (time, quickStart, booking = 'res') => {
        const checkResult = checkSlotTaken(time);
        if (checkResult !== false) {
            setSelectedTime(time);
            setQuickStart(quickStart);

            const startTime = new Date(checkResult?.startTime).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: timeFormatAmPm
            });

            const endTime = new Date(checkResult?.endTime).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: timeFormatAmPm
            });


            Modal.confirm({
                title: 'Confirm',
                content: <div style={{ marginLeft: '-32px' }}>
                    You have an existing booking from <b>{startTime}</b> to <b>{endTime}</b> {booking === 'res' ? "Would you like to modify it?" : 'Would you like to view booking?'}
                </div>,
                okText: 'Yes',
                cancelText: 'No',
                onOk() {
                    navigate("/bookingHist");
                },
                okButtonProps: { className: styles['confirm-ok-button'] },
                cancelButtonProps: { className: styles['confirm-cancel-button'] },
                onCancel() {
                    // console.log('Cancelled');
                },

            });

        }
        else {
            setIsSessionFormShow(!isSessionFormShow);
            setSelectedTime(time);
            setQuickStart(quickStart);
        }

    }


    // { console.log('location data in user dash: ', locationData, res.length, nonRes.length) }
    let content;
    if (locationData[0]?.active === false && !isUserTester) {
        content = (
            <div className={styles['breathe-card']}>

                <div className={styles['breathe-pulse']} />

                <div className={styles['breathe-content']}>
                    <span className={styles['breathe-brand']}>Charging Reimagined</span>
                    <h3 className={styles['breathe-headline']}>BREATHE EV</h3>
                    <span className={styles['breathe-status']}>Coming Soon</span>
                </div>
            </div>
        );
    }
     else if (chargingMethod === 'home') {
        content = (
            <HomeCharging key={selectedSubLocation?._id} subLocations={selectedSubLocation ? [selectedSubLocation] : subLocations} />
        );
    }
    else if (

        (res.length === 0 && nonRes.length === 0) ||
        (locationChargers && locationChargers.length === 0) ||
        (!locationData[0])

    ) {

        content = (
            <>
                {!isBookingLoading ?
                    <div className={styles['no-charging-stations']}>
                        <p>No charging stations available.</p>
                        {isGuest && !locationData[0] && (
                            <ButtonCustom
                                variant="primary"
                                text="Select a Location"
                                onClick={(e) => {
                                    // Guests can no longer reopen LocationList's own dropdown
                                    // to re-pick (it's disabled for them there), so this stale
                                    // selection is cleared instead - that re-triggers the
                                    // mandatory full-page location gate above.
                                    e.stopPropagation();
                                    localStorage.removeItem('selectedLocation');
                                    localStorage.removeItem('selectedLocationToken');
                                    setSelectedLocation(null);
                                }}
                            />
                        )}
                    </div>
                    :
                    <div className={styles.spinner}>
                        <FontAwesomeIcon icon={faBolt} size="3x" />
                    </div>
                }
            </>

        );
    }
    else if ((nonRes.length > 0 && res.length === 0) || (chargingMethod === 'non-reservable')) {
        content = (
            <NonReservable
                isLoading={isBookingLoading}
                locationTimezone={locationData[0]?.timezone}
                locationData={locationData[0]}
                chargingStations={filteredNonResConnectors}
                handleNewBooking={handleNewBooking}
                setIsSessionFormShow={setIsSessionFormShow}
                isSessionFormShow={isSessionFormShow}
                setSelectedChargerForNonRes={setSelectedChargerForNonRes}
                onSlotClick={timelineSlotClick}
            />
        );
    }
   
    else {
        content = (
            <TimelineHeatmap
                isLoading={isBookingLoading}
                chargingStations={chargingStationsConnectors}
                slotDuration={isUserTester ? 15 : 15}
                bookLimitDays={locationData[0]?.bookableDaysLimit || 1}
                timeFormatAmPm={timeFormatAmPm}
                onSlotClick={timelineSlotClick}
                date={selectedDate}
                setDate={changeDate}
                currentTime={new Date()}
                enableQuickStart={true}
                locationTimezone={locationData[0]?.timezone}
            />
        );
    }

    const NonReservableChargersCount = chargingStationsNonReservable?.filter(
        charger => (!charger.bookedSlots || charger.bookedSlots.length === 0)
    )?.length;
    return (
        <div className={styles['user-dashboard-container']}>
            <ToastContainer></ToastContainer>

            <Container>
                {/* <UpcomingBooking timeFormatAmPm={timeFormatAmPm} /> */}
                {/* {console.log("chargingStations",chargingStationsNonReservable)} */}
                {!ismapView && (
                    <MoreInfo
                        freeTime={''}
                        rate={'$0.35'}
                        idleFees={`${locationData[0]?.idleFee}`}
                        locationData={locationData}
                        chargerData={chargingStationsConnectors.length > 0 ? chargingStationsConnectors : chargingStationsNonReservableConnectors}
                        userGroups={userGroups}
                        usersFreeChargingLocations={usersFreeChargingLocations}
                        allChargingStations={[...chargingStationsNonReservableConnectors, ...chargingStationsNonReservableOfflineConnectors, ...chargingStationsConnectors]} // Combine both arrays
                    />
                )}
                <LocationList switchMapView={() => { setIsMapView(!ismapView) }} isMapView={ismapView} isLoading={isBookingLoading} locations={location} locationData={locationData} nearbyPublicLocations={nearbyPublicLocations} setLocationCallBack={setLocationCallBack} selectedLocationPast={selectedLocation} />
                <div className={`${styles.squareContainer} ${ismapView ? styles.mapView : ''} `} >
                    {ismapView ? <MapView timeFormatAmPm={timeFormatAmPm} switchMapView={() => { setIsMapView(false) }} /> :
                        <>
                            {
                                ((locationData[0]) && (locationChargers === null || chargingMethod === null && isBookingLoading)) ? ( //
                                    <div className={styles.spinner}>
                                        <FontAwesomeIcon icon={faBolt} size="3x" />
                                    </div>
                                ) : (
                                    <>
                                        {/* {console.log(res.length, nonRes.length,chargingStationsNonReservable?.length, chargingStations?.length)} */}
                                        {/* res.length !==0 && */}
                                        {/* {console.log("rendering selection",( (String(subLocations?.[0]?.parentLocation[0]) === String(selectedLocation))), subLocations?.[0]?._id, selectedLocation)} */}
                                        {((nonRes.length !== 0 || 
                                        ((subLocations?.[0]?.subLocationType === "CONDO") && (String(subLocations?.[0]?.parentLocation[0]) === String(selectedLocation))
                                            &&(nonRes.length !== 0 || res.length !== 0 || condoSubLocations.length > 1)
                                    ))
                                        && (locationData[0]?.active === true || isUserTester)) &&  (
                                            <><ChargingMethodSelector
                                                selected={chargingMethod}
                                                onSelectionChange={(value) => setChargingMethod(value)}
                                                nonReservableCount={filteredNonResConnectors.length}
                                                onNonResSearch={(term) => setNonResFilter(term)}
                                                resCount={res.length}
                                                nonResCount={nonRes.length}
                                                subLocations={subLocations}
                                                condoSubLocations={condoSubLocations}
                                                selectedSubLocationId={selectedSubLocation?._id}
                                                onSubLocationChange={(id) => setSelectedSubLocationId(id)}
                                                location={locationData[0]}
                                            />
                                           
                                            </>
                                        )}

                                        {content}
                                    </>
                                )
                            }
                        </>

                    }
                </div>
            </Container>

            {isSessionFormShow && !selectedChargerForNonRes && <Modal open={isSessionFormShow} onCancel={() => { setIsSessionFormShow(!isSessionFormShow); setExtraTimeList([]); setSelectedChargerForNonRes(null) }} footer={null}>
                {/* {console.log("selected charger in booking form ", selectedChargerForNonRes)} */}
                {isSessionFormShow && <BookingForm
                    costPerMinute={costPerMinute}
                    selectedLocation={selectedLocation}
                    handleNewBooking={handleNewBooking}
                    selectedTime={selectedChargerForNonRes ? new Date().setSeconds(0, 0) : selectedTime}
                    makeToast={(type, text) => { handleToast(type, text) }}
                    extraTimeList={extraTimeList}
                    setExtraTimeList={setExtraTimeList}
                    quickStart={quickStart}
                    locationData={locationData}
                    bookedSlots={chargingStationsConnectors}
                    selectedChargerForNonRes={selectedChargerForNonRes}
                />}
            </Modal>}

            {isSessionFormShow && selectedChargerForNonRes && <Modal open={isSessionFormShow} onCancel={() => { setIsSessionFormShow(!isSessionFormShow); setExtraTimeList([]); setSelectedChargerForNonRes(null) }} footer={null}>
                {/* {console.log("selected charger in booking form ", selectedChargerForNonRes)} */}
                {isSessionFormShow && <BookingFormNonRes
                    costPerMinute={costPerMinute}
                    selectedLocation={selectedLocation}
                    handleNewBooking={handleNewBooking}
                    selectedTime={selectedChargerForNonRes ? new Date().setSeconds(0, 0) : selectedTime}
                    makeToast={(type, text) => { handleToast(type, text) }}
                    extraTimeList={extraTimeList}
                    setExtraTimeList={setExtraTimeList}
                    quickStart={quickStart}
                    locationData={locationData}
                    bookedSlots={chargingStations}
                    selectedChargerForNonRes={selectedChargerForNonRes}
                />}
            </Modal>}
        </div>
    );
}



UserDashboard.propTypes = {
    user: PropTypes.string,
    userID: PropTypes.string,
    location: PropTypes.array,
    favLocation: PropTypes.array,
    type: PropTypes.string,
    timeFormatAmPm: PropTypes.bool,
    isUserTester: PropTypes.bool,
    userGroups: PropTypes.array,
    usersFreeChargingLocations: PropTypes.array,
    // balance: PropTypes.number,
}
const mapStateToProps = state => ({
    user: state.auth && state.auth.user ? state.auth.user.firstName : null,
    userID: state.auth && state.auth.user ? state.auth.user._id : null,
    location: state.auth && state.auth.user ? state.auth.user.location : null,
    favLocation: state.auth && state.auth.user ? state.auth.user.favLocation : null,
    type: state.auth && state.auth.user ? state.auth.user.type : null,
    timeFormatAmPm: state.auth && state.auth.user ? state.auth.user.timeFormatAmPm : false,
    isUserTester: state.auth && state.auth.user ? state.auth.user.isUserTester : false,
    userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
    usersFreeChargingLocations: state.auth && state.auth.user ? state.auth.user.freeChargingAllowedLocations : [],
    isGuest: state.auth && state.auth.user ? state.auth.user.isGuest : false,
    //  balance: state.auth && state.auth.user ? state.auth.user.wallet.coins: null,
    //isAuthenticated : state.auth.isAuthenticated,

})
export default connect(mapStateToProps, {})(UserDashboard)